var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M16.511 8.684c0-.544-.044-1.09-.138-1.625H8.827v3.08h4.321a3.7 3.7 0 0 1-1.599 2.431v2h2.578c1.514-1.394 2.384-3.452 2.384-5.886"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M8.827 16.5c2.157 0 3.977-.708 5.303-1.93l-2.578-2c-.718.488-1.644.765-2.722.765-2.087 0-3.857-1.408-4.492-3.302h-2.66v2.061a8 8 0 0 0 7.149 4.407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M4.336 10.034a4.8 4.8 0 0 1 0-3.063V4.91H1.678a8 8 0 0 0 0 7.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M8.827 3.666a4.35 4.35 0 0 1 3.069 1.2l2.284-2.284A7.7 7.7 0 0 0 8.827.5a8 8 0 0 0-7.15 4.409l2.658 2.06c.632-1.896 2.405-3.304 4.492-3.304"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667.5h16v16h-16z"
  })))));
};
export default SvgGoogle;